import { useContext } from "react"
import ProfileMenuContext from "context/ProfileMenuContext"

const useProfileMenuContext = () => useContext(ProfileMenuContext)

export default useProfileMenuContext